import React from "react";

import HotelClassicViewOffer from "./HotelClassicViewOffer";

import HotelClassicViewOfferTableRow from "./HotelClassicViewOfferTableRow";

import Select from "react-select";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  setHotelOfferInfos,
  setHotelPage,
  setHotelSort,
} from "amadeusredux/lib/hotelSlice";
import OfferPriceChart from "./OfferPriceChart";

import { FaThLarge, FaThList } from "react-icons/fa";
import { PAGESIZE } from "../config";
import {
  hotelSortOptions,
  boardTypes,
  getTexts,
  propertyFromArray,
  roomTypes,
  roomViews,
  views,
  roomAttributes,
} from "../utils";
import { search } from "amadeusredux/lib/api";
import LoadBar from "../components/LoadBar";
import { setRoomAttributesFilter } from "amadeusredux/lib/filterSlice";

const aggregateProp = (offer, aggregate, propname, prop) => {
  if (!aggregate[propname]) {
    aggregate[propname] = {
      [prop]: {
        count: 1,
        min: offer.PriceInfo.Price.value * 1,
        max: offer.PriceInfo.Price.value * 1,
      },
    };
  } else {
    if (!aggregate[propname][prop]) {
      aggregate[propname][prop] = {
        count: 1,
        min: offer.PriceInfo.Price.value * 1,
        max: offer.PriceInfo.Price.value * 1,
      };
    } else {
      aggregate[propname][prop].count += 1;
      if (offer.PriceInfo.Price.value * 1 < aggregate[propname][prop].min) {
        aggregate[propname][prop].min = offer.PriceInfo.Price.value * 1;
      }
      if (offer.PriceInfo.Price.value * 1 > aggregate[propname][prop].max) {
        aggregate[propname][prop].max = offer.PriceInfo.Price.value * 1;
      }
    }
  }
};

export default function HotelClassicViewOffers(props) {
  const {
    clientFilters,

    hotel,
  } = props;

  const intl = useIntl();
  //console.log(intl.locale);
  const df = new Intl.DateTimeFormat(intl.locale, {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
  });

  const loading = useSelector((state) => state.system.loading);

  const hotelPage = useSelector((state) => state.hotel.hotelPage);
  const hotelSort = useSelector((state) => state.hotel.hotelSort);
  const tourOperators = useSelector((state) => state.properties.tourOperators);
  const dispatch = useDispatch();
  const [viewTyp, setViewTyp] = React.useState("list");
  const hotelSpecialAmount = useSelector(
    (state) => state.hotel.hotelSpecialAmount
  );

  const selectedRoomAttributes = useSelector(
    (state) => state.filter.selectedRoomAttributes
  );

  const specialRoomType = useSelector((state) => state.search.specialRoomType);
  const outbounddate = useSelector((state) => state.search.outbounddate);
  let offers = [];
  const hotelOfferInfos = useSelector((state) => state.hotel.hotelOfferInfos);

  const selectedMarketingActions = useSelector(
    (state) => state.search.selectedMarketingActions
  );
  const hotelMarketingActions = useSelector(
    (state) => state.filter.hotelMarketingActions
  );

  const reservationoperatorsonly = useSelector(
    (state) => state.search.reservationoperatorsonly
  );

  const optionOperators = useSelector((state) => state.filter.optionOperators);

  if (hotelOfferInfos.Offers) offers = hotelOfferInfos.Offers.Offer;
  let geodata = hotelOfferInfos.GeoDictionary;
  let hotels = hotelOfferInfos.HotelDictionary;
  let stations = hotelOfferInfos.StationDictionary;

  /*if (!outbounddate) {
    let touropcheck = [];
    let tmpoffers = [];
    for (let i = 0; i < offers.length; i++) {
      
      if(!offers[i]?.TourOperator?.TourOperatorCode) continue;
      if(!touropcheck.includes(offers[i].TourOperator.TourOperatorCode))
      {
        touropcheck.push(offers[i].TourOperator.TourOperatorCode);
        tmpoffers.push({...offers[i]});
      }
    }

    offers= [...tmpoffers];
  }*/

  const changeChoosenOffers = (offer) => {
    /*console.log(offer);*/
    let tmp = [...hotelOfferInfos.Offers.Offer];

    for (let i = 0; i < tmp.length; i++) {
      if (
        tmp[i].TourOperator.TourOperatorCode ===
        offer.TourOperator.TourOperatorCode
      ) {
        tmp[i] = { ...offer };
        break;
      }
    }

    dispatch(
      setHotelOfferInfos({ ...hotelOfferInfos, Offers: { Offer: tmp } })
    );
  };

  if (
    Array.isArray(clientFilters.excludeTourOperators) &&
    clientFilters.excludeTourOperators.length > 0
  ) {
    offers = offers.filter(
      (offer) =>
        !clientFilters.excludeTourOperators.includes(
          offer.TourOperator.TourOperatorCode
        )
    );
  }
  /*if (Array.isArray(offers) && offers.length > 0) {
    console.log(
      offers[0].OfferServices?.Package?.Flight?.OutboundFlight?.FlightDeparture
    );
  }*/

  if (reservationoperatorsonly) {
    offers = offers.filter((e) => {
      return (
        Array.isArray(optionOperators) &&
        optionOperators.find(
          (o) => o.touroperator === e.TourOperator?.TourOperatorCode
        )
      );
    });
  }

  const offersRoomAttributes = {};
  const filteredAttributes = {};

  for (let i = 0; i < offers.length; i++) {
    if (
      Array.isArray(
        offers[i].OfferServices?.Package?.Accommodation?.Room?.RoomAttributes
      )
    ) {
      for (
        let j = 0;
        j <
        offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes
          .length;
        j++
      ) {
        if (
          roomAttributes[
            offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[j]
          ]
        ) {
          offersRoomAttributes[
            offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[j]
          ] = {
            label:
              roomAttributes[
                offers[i].OfferServices.Package.Accommodation.Room
                  .RoomAttributes[j]
              ],
          };
          if (
            selectedRoomAttributes.includes(
              offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[
                j
              ]
            )
          ) {
            filteredAttributes[
              offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[
                j
              ]
            ] = { selected: 1 };
          }
        } else {
          console.log(
            ">>>>>>>>>>>>>>>>>>>>>>>>>>>>> unknon roomattributre",
            offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[j]
          );
        }
      }
    }
  }

  let allma = hotelMarketingActions.map((e) => e.label).join();

  let selma = [...selectedMarketingActions];

  selma = selectedMarketingActions.filter((e) => allma.indexOf(e) > -1);

  if (selma.length > 0) {
    offers = offers.filter((e) => {
      let found = false;
      if (!Array.isArray(e.MarketingActions)) return true;
      for (let i = 0; i < e.MarketingActions.length; i++) {
        if (e.MarketingActions[i].MarketingProperties === null) continue;
        if (selma.includes(e.MarketingActions[i].MarketingProperties.label)) {
          found = true;
        }
      }
      return found;
    });
  }

  if (Object.keys(filteredAttributes).length > 0) {
    let neededAttributes = Object.keys(filteredAttributes).length;
    offers = offers.filter((e) => {
      let propsfound = 0;
      if (
        !Array.isArray(
          e.OfferServices?.Package?.Accommodation?.Room?.RoomAttributes
        )
      )
        return false;
      for (
        let i = 0;
        i <
        e.OfferServices?.Package?.Accommodation?.Room?.RoomAttributes.length;
        i++
      ) {
        if (
          filteredAttributes[
            e.OfferServices?.Package?.Accommodation?.Room?.RoomAttributes[i]
          ]
        ) {
          propsfound = propsfound + 1;
        }
      }
      return propsfound === neededAttributes;
    });
  }

  const offersRoomAttributesAfterFilter = {};

  for (let i = 0; i < offers.length; i++) {
    if (
      Array.isArray(
        offers[i].OfferServices?.Package?.Accommodation?.Room?.RoomAttributes
      )
    ) {
      for (
        let j = 0;
        j <
        offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes
          .length;
        j++
      ) {
        let attribute =
          offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[j];
        if (roomAttributes[attribute]) {
          if (!offersRoomAttributesAfterFilter[attribute]) {
            offersRoomAttributesAfterFilter[attribute] = {
              count: 1,
            };
          } else {
            offersRoomAttributesAfterFilter[attribute].count =
              offersRoomAttributesAfterFilter[attribute].count + 1;
          }
        }
      }
    }
  }

  React.useEffect(() => {
    dispatch(
      setRoomAttributesFilter({
        offersRoomAttributesAfterFilter,
        offersRoomAttributes,
        filteredAttributes,
      })
    );
  }, [hotelOfferInfos, selectedRoomAttributes]);
  
  let rnames = hotelSpecialAmount.map((e) => e.value).join();

  let sprt = [...specialRoomType];

  sprt = sprt.filter((e) => rnames.indexOf(e) > -1);

  //console.log("###########",rnames);
  if (sprt.length > 0) {
    offers = offers.filter((e) => {
      let found = true;
      if (!Array.isArray(e.MarketingActions)) return false;
      if (e.MarketingActions.length < 1) return false;

      let roomnames = e.MarketingActions[0].RoomMouseover;

      if (!roomnames) return false;

      for (let j = 0; j < sprt.length; j++) {
        if (roomnames.indexOf(sprt[j]) === -1) {
          found = false;
        }
      }

      return found;
    });
  }

  let aggregateddata = [];

  let aggsorted = [...offers];
  aggsorted.sort(
    (a, b) =>
      new Date(
        a.OfferServices?.Package?.Flight?.OutboundFlight?.FlightDeparture?.DepartureDate
      ) -
      new Date(
        b.OfferServices?.Package?.Flight?.OutboundFlight?.FlightDeparture?.DepartureDate
      )
  );
  let lastaggregate = "";
  let aggregate = {};
  for (let i = 0; i < aggsorted.length; i++) {
    let offer = aggsorted[i];
    if (
      lastaggregate !==
      offer.OfferServices?.Package?.Flight?.OutboundFlight?.FlightDeparture
        ?.DepartureDate
    ) {
      if (aggregate.date) {
        aggregateddata.push(aggregate);
      }
      aggregate = {};
    }
    if (!aggregate.date)
      aggregate.date =
        offer.OfferServices?.Package?.Flight?.OutboundFlight?.FlightDeparture?.DepartureDate;
    if (!aggregate.count) aggregate.count = 0;
    aggregate.count += 1;
    if (offer.OfferServices?.Package?.Accommodation?.Room?.RoomType)
      aggregateProp(
        offer,
        aggregate,
        "roomtypes",
        offer.OfferServices.Package.Accommodation.Room.RoomType
      );
    if (offer.OfferServices?.Package?.Accommodation?.BoardType)
      aggregateProp(
        offer,
        aggregate,
        "boardtypes",
        offer.OfferServices.Package.Accommodation.BoardType
      );
    if (
      offer.OfferServices?.Package?.Flight?.OutboundFlight?.FlightDeparture
        ?.DepartureAirportRef?.AirportCode
    )
      aggregateProp(
        offer,
        aggregate,
        "airports",
        offer.OfferServices.Package.Flight.OutboundFlight.FlightDeparture
          .DepartureAirportRef.AirportCode
      );

    lastaggregate =
      offer.OfferServices?.Package?.Flight?.OutboundFlight?.FlightDeparture
        ?.DepartureDate;
    //
  }

  aggregateddata.push(aggregate);
  //let tourops = [];

  //console.log(aggregateddata);

  /*const bestoffersperto = [];
  for (let i = 0; i < offers.length; i++) {
    if (!tourops.includes(offers[i].TourOperator.TourOperatorName)) {
      tourops.push(offers[i].TourOperator.TourOperatorName);
      bestoffersperto.push(offers[i]);
    }
  }*/

  const offersForPage = offers.filter(
    (e, i) => i >= (hotelPage - 1) * PAGESIZE && i < hotelPage * PAGESIZE
  );

  let offCount = 0;

  return (
    <div className="hoteloffers" style={{ marginLeft: 16 }}>
      <div
        style={{
          boxSizing: "border-box",
          borderRadius: 8,
          padding: 16,
          boxShadow: " 0px 3px 15px 0px rgba(0, 0, 0, 0.1)",
          backgroundColor: "rgba(255,255,255,0.1)",
        }}
      >
        <OfferPriceChart offer={offers[0]} />
      </div>
      <br />
      <div style={{ display: "flex" }}>
        <div style={{ flexGrow: 1 }}>
          <Select
            className="offerviewselect"
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
            })}
            value={hotelSort}
            onChange={(val) => {
              dispatch(setHotelPage(1));
              dispatch(setHotelSort(val));
              search(dispatch, true, false);
            }}
            isSearchable={false}
            defaultValue={hotelSortOptions[0]}
            options={hotelSortOptions}
          />
        </div>
        <div style={{ flexShrink: 1 }}>
          <span
            onClick={() => setViewTyp(viewTyp == "list" ? "table" : "list")}
          >
            {viewTyp === "list" ? <FaThList /> : <FaThLarge />}
          </span>
        </div>
      </div>
      <br />

      <LoadBar
        offers={offers}
        view={"hotel"}
        text={
          "suche beste Angebote von " +
          (Array.isArray(tourOperators) && tourOperators.length > 0
            ? tourOperators[Math.floor(Math.random() * tourOperators.length)]
                .TourOperatorCode
            : "")
        }
      />

      {viewTyp === "table" && (
        <div className="tablerow" style={{ display: "flex" }}>
          <div
            style={{
              minWidth: "20%",
              width: "20%",
              maxWidth: "20%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              marginRight: 16,
            }}
          >
            Datum/Dauer/Abreiseflughafen
          </div>
          <div
            style={{
              minWidth: "20%",
              width: "20%",
              maxWidth: "20%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              marginRight: 16,
            }}
          >
            Zimmer/Verpflegung
          </div>
          <div
            style={{
              minWidth: "20%",
              width: "20%",
              maxWidth: "20%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              marginRight: 16,
            }}
          >
            Veranstalter
          </div>
          <div
            style={{
              minWidth: "10%",
              width: "10%",
              maxWidth: "10%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              marginRight: 16,
            }}
          >
            Gesamtpreis
          </div>
          <div
            style={{
              minWidth: "30%",
              width: "30%",
              maxWidth: "30%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              marginRight: 16,
            }}
          >
            ...
          </div>
        </div>
      )}
      {offersForPage.length === 0 && loading < 1 && (
        <span>
          Es wurden keine Angebote zu Ihrer Auswahl gefunden.
          <br />
        </span>
      )}
      {viewTyp === "table" &&
        offersForPage.map((offer) => {
          return (
            <HotelClassicViewOfferTableRow
              alternatives={true}
              hotel={hotel}
              offer={offer}
              geodata={geodata}
              hotels={hotels}
              stations={stations}
              changeChoosenOffers={(offer) => changeChoosenOffers(offer)}
            />
          );
        })}

      {viewTyp === "list" &&
        offersForPage.map((offer) => {
          offCount = offCount + 1;
          return (
            <HotelClassicViewOffer
              alternatives={true}
              hotel={hotel}
              offer={offer}
              offCount={offCount}
              geodata={geodata}
              hotels={hotels}
              stations={stations}
              changeChoosenOffers={(offer) => changeChoosenOffers(offer)}
            />
          );
        })}
      {offers.length > PAGESIZE && (
        <div className="hoteloffers3">
          Seiten{" "}
          {Array.from(Array(Math.ceil(offers.length / PAGESIZE)).keys()).map(
            (e) => (
              <span
                className="hoteloffers4"
                onClick={() => dispatch(setHotelPage(e + 1))}
              >
                &nbsp;&nbsp;{e + 1}&nbsp;&nbsp;|
                {(e + 1) % 20 === 0 ? <br /> : null}
              </span>
            )
          )}{" "}
          ({offers.length})
        </div>
      )}
    </div>
  );
}
